import { useEffect, useState } from "react";
import { connectSocket, getSocket } from "../socket";
import { parseRefresh } from "../utils/parsers";

// Subscribes to the socket "refresh" event while `enabled` is true and
// exposes overall progress, ETA and the current video list. `lastRefreshAt`
// changes on every event so other loaders (counts, day list) can follow.
export default function useSocketRefresh(enabled) {
  const [progress, setProgress] = useState(null);
  const [remainingMinutes, setRemainingMinutes] = useState(0);
  const [videos, setVideos] = useState([]);
  const [lastRefreshAt, setLastRefreshAt] = useState(0);

  useEffect(() => {
    if (!enabled) {
      setProgress(null);
      setRemainingMinutes(0);
      setVideos((prev) => (prev.length ? [] : prev));
      return undefined;
    }

    connectSocket();
    const socket = getSocket();

    const handleRefresh = (raw) => {
      const update = parseRefresh(raw);
      if (!update) return;
      if (update.progress !== undefined) setProgress(update.progress);
      if (update.remainingMinutes !== undefined) {
        setRemainingMinutes(update.remainingMinutes);
      }
      if (update.videos) setVideos(update.videos);
      setLastRefreshAt(Date.now());
    };

    socket.on("refresh", handleRefresh);
    return () => {
      socket.off("refresh", handleRefresh);
    };
  }, [enabled]);

  return { progress, remainingMinutes, videos, lastRefreshAt };
}
